import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './ModalReceipts.scss';

import commonConstant from '../../common/_commonConstant';
import { randomNumber } from '../../common/_commonFunction';
import {
  Modal,
  parkingTimeIn,
  minutesToMillisec,
  buildingName,
  validateToShowDash,
  paymentRefNo,
  vehicleLicensePlate,
  dateDDMMYYYYFormat,
  getTimeHHMMSS,
  validateMoney,
  calculateAmount,
  calculateVat,
  buildingCompanyName,
  buildingTaxID,
  buildingPosID,
  buildingRefNo,
  minutesToHr,
  calculateOvernight,
  paymentTotalFeeAmount,
  overnightAmount,
  paymentTotalAmount,
  vehicleProvince,
} from '../../helpers';

// Interim solution: this building gets a Coupon header instead of a receipt
const COUPON_BUILDING_REF_NO = '1010';

class ModalReceipts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndexReceipts': props.activeIndexReceipts ? props.activeIndexReceipts : 1,
      'items': null,
      'loading': true,
    };
  }

  UNSAFE_componentWillMount() {
    const { getParkingStatusById } = this.props;
    const { items } = this.state;

    if (!items && getParkingStatusById && getParkingStatusById.data) {
      this.handleReceipts();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { modal, getParkingStatusById, activeIndexReceipts, parkingID } = this.props;

    if (nextProps.modal && nextProps.modal !== modal) {
      this.setState({ 'activeIndexReceipts': nextProps.activeIndexReceipts ? nextProps.activeIndexReceipts : 1 });
      if (nextProps.parkingID === parkingID) {
        return null;
      }
      return this.handleReceipts(nextProps.getParkingStatusById);
    } else if (nextProps.getParkingStatusById && nextProps.getParkingStatusById.status === 200 && nextProps.getParkingStatusById !== getParkingStatusById) {
      return this.handleReceipts(nextProps.getParkingStatusById);
    } else if (nextProps.activeIndexReceipts !== activeIndexReceipts) {
      this.handleActivePagination(nextProps.activeIndexReceipts);
      return this.setState({ 'activeIndexReceipts': nextProps.activeIndexReceipts });
    }
  }

  handleReceipts = newGetParkingStatus => {
    try {
      const { getParkingStatusById, getBuildingByRefNo } = this.props;
      const data = newGetParkingStatus ? newGetParkingStatus.data : getParkingStatusById.data;

      if (!data || !data.payment) {
        return this.setState({ 'items': null });
      }

      // Backend requires buildingTaxID, buildings without real values send '0'
      const taxIDValue = buildingTaxID(getBuildingByRefNo);
      const taxID = taxIDValue && Number(taxIDValue) !== 0 ? taxIDValue : null;

      // Backend requires buildingPosID, buildings without real values send '0'
      const posIDValue = buildingPosID(getBuildingByRefNo);
      const posID = posIDValue && Number(posIDValue) !== 0 ? posIDValue : null;

      const isCouponBuilding = buildingRefNo(getBuildingByRefNo) === COUPON_BUILDING_REF_NO;

      let defaultFreeParkingTime = 0, sumParkingTime = 0;
      const checkParkingTimeIn = parkingTimeIn(data) ? parkingTimeIn(data) : null;

      const items = data.payment.map((ele, index) => {
        const startTime = checkParkingTimeIn ? sumParkingTime ? (checkParkingTimeIn + minutesToMillisec(sumParkingTime)) : checkParkingTimeIn : null;
        sumParkingTime += ele.paymentTotalParkingFeeMinutes + ele.paymentTotalBuildingFreeParkingMinutes + ele.paymentTotalRedemptionMinutes - (ele.paymentTotalRedemptionMinutes === 0 ? 0 : defaultFreeParkingTime);
        defaultFreeParkingTime += ele.paymentTotalBuildingFreeParkingMinutes;
        const hasVat = ele.paymentVatRatePercentage !== 0 && ele.paymentVatRatePercentage !== 100;

        return (
          <div className="box" key={randomNumber()}>
            <div className="box-recripts">
              <div className="building text" id="building-name">
                {buildingName(getBuildingByRefNo)}
              </div>
              <div className="address text" id="payment-company-name">
                {buildingCompanyName(getBuildingByRefNo)}
              </div>
              {
                taxID ?
                  <div className="tax text">TAX ID : <span className="payment-tax-id">{taxID}</span></div> : null
              }
              <hr className="hr" />
              <div className="title">{isCouponBuilding ? 'Parking Coupon' : 'Receipt/ Tax Invoice (ABB)'}</div>
              {
                posID ?
                  <div className="detail-row">
                    <div className="label">POS ID</div>
                    <div className="value" id={`payment-pos-id-${index}`}>
                      {posID}
                    </div>
                  </div> : null
              }
              <div className="detail-row">
                <div className="label">Ref ID</div>
                <div className="value" id={`payment-ref-number-${index}`}>
                  {validateToShowDash(paymentRefNo(ele))}
                </div>
              </div>
              <div className="detail-row">
                <div className="label">License no.</div>
                <div className="value" id={`payment-license-plate-${index}`}>{validateToShowDash(vehicleLicensePlate(data))}</div>
              </div>
              <div className="detail-row">
                <div className="label">Province</div>
                <div className="value" id={`payment-vehicle-province-${index}`}>{validateToShowDash(vehicleProvince(data))}</div>
              </div>
              <div className="detail-row">
                <div className="label">เริ่มตั้งแต่เวลา</div>
                <div className="value" id={`payment-start-time-${index}`}>
                  {validateToShowDash(dateDDMMYYYYFormat(startTime))} {validateToShowDash(getTimeHHMMSS(startTime))}
                </div>
              </div>
              <div className="detail-row">
                <div className="label">สิทธิ์จอดรถฟรีรวม</div>
                <div className="value" id={`payment-total-free-minutes-${index}`}>
                  {
                    ele.paymentTotalRedemptionMinutes ?
                      minutesToHr((ele.paymentTotalRedemptionMinutes - defaultFreeParkingTime))
                      : minutesToHr(ele.paymentTotalBuildingFreeParkingMinutes)
                  } ชม.
                </div>
              </div>
              <div className="detail-row">
                <div className="label">จอดได้ถึง</div>
                <div className="value" id={`payment-end-time-${index}`}>
                  <span>{validateToShowDash(dateDDMMYYYYFormat(new Date(checkParkingTimeIn).setMinutes(new Date(checkParkingTimeIn).getMinutes() + sumParkingTime)))}</span>
                  <span> {validateToShowDash(getTimeHHMMSS(new Date(checkParkingTimeIn).setMinutes(new Date(checkParkingTimeIn).getMinutes() + sumParkingTime)))}</span>
                </div>
              </div>
              <hr className="hr" />
              <div className="detail-row btw">
                <div className="label">Parking fee amount (Baht)</div>
                <div className="value" id={`payment-parking-fee-${index}`}>
                  {validateMoney(isCouponBuilding ? paymentTotalFeeAmount(ele) : calculateAmount(ele))}
                </div>
              </div>
              <div className="detail-row btw">
                <div className="label">Overnight charge amount (Baht)</div>
                <div className="value" id={`payment-overnight-${index}`}>
                  {validateMoney(isCouponBuilding ? overnightAmount(ele) : calculateOvernight(ele))}
                </div>
              </div>
              {
                taxID && hasVat && !isCouponBuilding ?
                  <div className="detail-row btw">
                    <div className="label">{`Vat ${ele.paymentVatRatePercentage - 100}% (Baht)`}</div>
                    <div className="value" id={`payment-vat-${index}`}>
                      {validateMoney(calculateVat(ele))}
                    </div>
                  </div> : null
              }
              <hr className="hr" />
              <div className="detail-row btw">
                <div className="label">Total amount (Baht)</div>
                <div className="value" id={`payment-total-fee-${index}`}>
                  {validateMoney(paymentTotalAmount(ele))}
                </div>
              </div>
              {
                taxID && hasVat && !isCouponBuilding ? <div className="vat">(ITEM VAT INCLUDED)</div> : null
              }
              <div className="box-logo">
                <img className="logo" src={commonConstant.ezyParkLogo} alt="" />
                <span className="text-logo">
                  <div className="title">EZY PARKING</div>
                  <div className="description">SMART PAYMENT SOLUTION</div>
                </span>
              </div>
            </div>
          </div>
        );
      });

      return this.setState({ items });
    } catch (error) {
      return null;
    }
  }

  handleCheckSetPage = activeIndexReceipts => {
    const { getParkingStatusById } = this.props;

    if (!activeIndexReceipts || activeIndexReceipts > getParkingStatusById.data.payment.length) {
      return null;
    }
    this.handleActivePagination(activeIndexReceipts);
    return this.setState({ activeIndexReceipts });
  }

  handleActivePagination = activeIndexReceipts => {
    try {
      const activeIndex = activeIndexReceipts ? activeIndexReceipts : this.state.activeIndexReceipts;

      document.querySelector('.pagination-item.active').className = 'pagination-item';
      return document.getElementById(`pagination-item-${activeIndex}`).className += ' active';
    } catch (error) {
      return null;
    }
  }

  render() {
    const { modal, handleShow, getParkingStatusById } = this.props;
    const { items, activeIndexReceipts } = this.state;

    if (!getParkingStatusById.data || !items || items.length === 0 || !activeIndexReceipts) {
      return null;
    }

    return (
      <Modal show={modal} handleToggle={handleShow} >
        <div className="ModalReceipts">
          <div className="box-btn-close">
            <span className="icon fas fa-times" id="btn-close-receipt" onClick={handleShow} />
          </div>
          {
            getParkingStatusById.data.payment.length > 1 ?
              <div className="box-pagination">
                <span
                  id="receipt-prev-page"
                  className={`box-arrow left fas fa-chevron-left${activeIndexReceipts > 1 ? ' active' : ''}`}
                  onClick={() => this.handleCheckSetPage(activeIndexReceipts - 1)}
                />
                <span
                  id="receipt-next-page"
                  className={`box-arrow right fas fa-chevron-right${activeIndexReceipts === getParkingStatusById.data.payment.length ? '' : ' active'}`}
                  onClick={() => this.handleCheckSetPage(activeIndexReceipts + 1)}
                />
              </div>
              : null
          }
          {items[activeIndexReceipts - 1]}
          <div className="box-pagination-dot">
            {
              items.map((element, index) => (
                <span
                  className={`pagination-item${activeIndexReceipts === index + 1 ? ' active' : ''}`}
                  id={`pagination-item-${index + 1}`}
                  onClick={() => this.handleCheckSetPage(index + 1)}
                  key={randomNumber()}
                >
                  {index + 1}
                </span>
              ))
            }
          </div>
        </div>
      </Modal>
    );
  }
}

ModalReceipts.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'modal': PropTypes.bool,
  'handleShow': PropTypes.func,
  'activeIndexReceipts': PropTypes.any,
  'parkingID': PropTypes.any,
  'getParkingStatusById': PropTypes.shape({
    'data': PropTypes.shape({
      'payment': PropTypes.array,
    }),
    'status': PropTypes.any,
  }),
  'getBuildingByRefNo': PropTypes.shape({}),
};

const mapStateToProps = ({ getParkingStatusById, getBuildingByRefNo }) => ({
  getParkingStatusById,
  'getBuildingByRefNo': getBuildingByRefNo.data,
});

export default connect(mapStateToProps)(ModalReceipts);
